import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import styled from "styled-components";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, Box } from "@mui/material";
import { Grid } from "@mui/material";
import "./sidebar.css";
import "../../Style/defaultstyle.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../Style/defaultstyle.scss";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BanneServerApplication from "../../container/Banner/banner-serverApplication";
import DividerComponent from "../../container/Divider/divider";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";

// Titlecloudcompute
function EventSourcing() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Event Sourcing - Serverless Application - 프라이빗 클라우드";
    }, []);
    return (
        <div className="App">
            <NavButton
                option={{
                    // logo: logoKube,
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061ff" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            {/* {Banner("Hanbiro", "Microservice architecture")} */}
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Event Sourcing")} */}

                        <BoxContent>
                            <BoxText>
                                <p class="typo-14">• CQRS 를 구현하는 서비스형 Serverless 서비스</p>
                            </BoxText>
                            <BoxText>
                                <p class="typo-14">• Application 의 모든 상태를 일으키는 이벤트를 순서대로 저장 - 기존방식은 마지막 상태값만 저장</p>
                            </BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/event-sourcing/event-sourcing-1.svg"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}>
                                <Typography className="sub-title normal" sx={CardTitle} variant="h6">
                                    <p class="typo-21 typo-medium typo-black">특징</p>
                                </Typography>
                            </Box>
                            <BoxText>
                                <p class="typo-14">• 마이크로서비스별 독립적인 확장과 유지보수, 빠르게 빌드 배포가능</p>
                            </BoxText>
                            <BoxText>
                                <p class="typo-14">• 각각의 오류는 해당기능에만 발생하며 빠르게 수정, 정상화 가능</p>
                            </BoxText>
                            <BoxText>
                                <p class="typo-14">• Write 의 비동기 작동으로 처리응답을 기다리지 않고 화면전환</p>
                            </BoxText>
                            <BoxText>
                                <p class="typo-14">• 읽기 쪽의 데이터베이스 구성</p>
                            </BoxText>
                            <BoxSubText>
                                <p class="typo-14">- 쿼리에 최적화된 스키마를 정의하며</p>
                            </BoxSubText>
                            <BoxSubText>
                                <p class="typo-14">- 단순한 쿼리로 최적화된 읽기 구현</p>
                            </BoxSubText>
                            <BoxSubText>
                                <p class="typo-14">- 데이터베이스의 교체, 전체 재구성, 과거상태 재구성 가능</p>
                            </BoxSubText>
                        </BoxContent>
                        <DividerComponent />

                        {/*}
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="titlecard normal" sx={CardTitle} variant="h6">• 가격</Typography></Box>
                            <br/>
                            <CommonTable header={config.tb4_header} content={config.tb4_content} />
                            <br/>
                            <CommonTable header={config.tb5_header} content={config.tb5_content} />
                        </BoxContent>
                        */}
                        <BoxContent>
                            <Box>
                                <Typography className="sub-title normal" sx={CardTitle} variant="h6">
                                    <p class="typo-21 typo-medium typo-black">AWS 의 CQRS</p>
                                </Typography>
                            </Box>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg"></ImageWrap>
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            {/* <Cloudconsult /> */}
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

const BoxSubText = styled.div`
    margin-left: 7%;
`;

const CardTitle = {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "맑은고딕, Dotum, 돋움, sans-serif !important;",
};

const TitleWrap = {
    height: "40px",
};

// const Box = styled.div`
//   @media only screen and (max-width: 767px){
//     font-size: 80%;
//   }
// `

const BoxContent = styled.div`
    ${
        "" /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */
    }
    text-align: left;
`;

const BoxText = styled.div`
    margin: 0px !important;
    line-height: 2em;
`;

const ImageWrap = styled.img`
    width: 100%;
    object-fit: fill;
`;

export default EventSourcing;
